export var createFonts = function (os) {
    var webFamily = "'Open Sans', sans-serif";
    switch (os) {
        case "web":
            return {
                light: {
                    fontFamily: webFamily,
                    fontWeight: "300",
                },
                regular: {
                    fontFamily: webFamily,
                    fontWeight: "400",
                },
                semibold: {
                    fontFamily: webFamily,
                    fontWeight: "600",
                },
                bold: {
                    fontFamily: webFamily,
                    fontWeight: "700",
                },
            };
        default:
            return {
                light: {
                    fontFamily: "OpenSans-Light",
                },
                regular: {
                    fontFamily: "OpenSans-Regular",
                },
                semibold: {
                    fontFamily: "OpenSans-SemiBold",
                },
                bold: {
                    fontFamily: "OpenSans-Bold",
                },
            };
    }
};
//# sourceMappingURL=fonts.js.map